<template>
  <div class="tva-presentation" ref="presentation">
    <!-- <div
      :style="{ width: `${status !== 'segment-fast' ? progress * 100 : 100}%` }"
      :class="[
        'tva-progress',
        status === 'segment'
          ? 'unactive'
          : status === 'segment-fast'
          ? 'waiting'
          : ''
      ]"
    ></div> 
    <div class="box" ref="box">
      <div class="slide-number">
        {{
          status === "segment-fast"
            ? previousIndex + 1
            : status === "transition"
            ? previousIndex + 1 + " &#8594; " + (index + 1)
            : index + 1
        }}
      </div>
    </div>
    -->
    <BodymovinSlider
      v-if="segments && transitions"
      :index="index"
      :path="`${this.baseUrl}videos/tutorial_${$ml.current}.json`"
      :segments="segments"
      :transitions="transitions"
      :frameRate="1"
      v-on:status="status = $event"
      v-on:progress="progress = $event"
      v-on:direction="direction = $event"
    />
  </div>
</template>

<script>
import BodymovinSlider from "./BodymovinSlider.vue";
import axios from "axios";
import _ from "lodash";

export default {
  props: ["index"],
  created() {
    axios
      .get(`${this.baseUrl}videos/tutorial_${this.$ml.current}.json`)
      .then(response => {
        // handle success
        this.data = response.data;
      })
      .catch(error => {
        // handle error
        console.log(error);
      });
  },
  mounted() {},
  data() {
    return {
      previousIndex: 0,
      progress: 0,
      status: "",
      direction: "",
      baseUrl: process.env.BASE_URL,
      data: null,
      fullScreen: false
    };
  },
  computed: {
    segments() {
      if (this.data) {
        let string = this.data.layers[0].t.d.k[0].s.t;
        let array = JSON.parse(string);
        // console.log("segments: ", array);
        return array;
      }
    },
    transitions() {
      if (this.data) {
        let string = this.data.layers[1].t.d.k[0].s.t;
        let array = JSON.parse(string);
        // let sliced = array.slice(1, array.length - 1);
        // console.log("transitions: ", array);
        return array;
      }
    }
  },
  watch: {
    index(value, oldValue) {
      this.previousIndex = oldValue;
    }
  },
  components: {
    BodymovinSlider
  }
};
</script>

<style lang="scss" scoped>
.tva-presentation {
  //border: 2px solid deeppink;
  height: 100vh;
  color: #fff;
  position: fixed;
  top: 0;
  right: -20vw;
  display: flex;
  justify-content: center;
  align-items: center;

  // background: rgba(#150e1b, 0.9);
  z-index: -1;
  .tva-progress {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 0.6vh;
    z-index: 1;
    background: #fed300;
    &.unactive {
      opacity: 0;
    }
    &.waiting {
      animation: pulse 0.7s linear;
      @keyframes pulse {
        25% {
          opacity: 1;
        }
        75% {
          opacity: 0;
        }
      }
    }
  }
  .box {
    width: calc(100vh / 9 * 16);
    height: 100vh;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    background: #150e1b;
    position: relative;
    .slide-number {
      position: absolute;
      top: 13px;
      left: 13px;
      z-index: 1;
    }
    .video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      video {
        width: 91.06%;
      }
    }
  }
  @media (max-aspect-ratio: 16/9) {
    .box {
      width: 100%;
      height: calc(100vw / 16 * 9);
    }
  }
}
</style>
